module.exports = __webpack_public_path__ + "static/colgadas-018-de42823c9e7e0366a6f6767b533c6727.jpg";